import { render, staticRenderFns } from "./DetailsWidget.vue?vue&type=template&id=638ffe8c&"
import script from "./DetailsWidget.vue?vue&type=script&lang=js&"
export * from "./DetailsWidget.vue?vue&type=script&lang=js&"
import style0 from "./DetailsWidget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports